import { render, staticRenderFns } from "./indikator_kinerja.vue?vue&type=template&id=6d93f852&"
import script from "./indikator_kinerja.vue?vue&type=script&lang=js&"
export * from "./indikator_kinerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports